
export default ({ trigger }, resolve, self) => {
  if (trigger !== 'popstate') {
    self.expandMenuItem(trigger, resolve);
  } else {
    resolve();
  }
}
